import {
  IconAtom,
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
} from '@assets/images/icon';
import { IconAnalyze, IconZoom, schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';
import { accessAuto1, accessAutoMain, accessPro1, accessProMain, accesscontroller1, accesscontrollerMain } from '@assets/images/main/access/product';
import { assetTracking1, workerTracking1 } from '@assets/images/main/rtls/product';

export default {
  specTitle: {},

  specData: [
    {
      data: [{ title: '제품명' }, { text1: '모바일 출입' }, { text2: '자동문 출입' }, { text3: '얼굴 인식 출입' }],
    },
    {
      data: [
        { text: '설명' },
        { text: '모바일 앱으로 출입문을 제어하는 매우 간편한 기기' },
        { text: '앱 실행없이 편리한 출입이 가능한 기기' },
        { text: '얼굴인식, NFC카드 등 다양한 출입을 한번에 사용가능한 기기' },
      ],
    },
    {
      data: [{ text: '전원 공급' }, { text: '배터리 사용(최대 3년사용)' }, { text: 'DC 12V, 24V ' }, { text: 'DC 12V, 3A' }],
    },
  ],

  a: [
    { text: '통신 대역', icon: IconSignal },
    { text: '통신 범위', icon: IconCoil },
    { text: '정확도', icon: IconRuler },
    { text: '자산찾기', icon: IconSearch },
    { text: '각도 측정(AoA)', icon: IconRuler },
    { text: '정밀 추적(ATDoA)', icon: IconAtom },
    { text: '전원', icon: IconPower },
    { text: '배터리 소모', icon: IconEnergyCircle },
    { text: '설치 난이도', icon: IconTools },
    { text: '활용 공간', icon: IconBuildings },
    { text: '추천 환경', icon: IconBookmark },
    { text: '특장점', icon: IconPencil },
    { text: '외부 연동', icon: IconShare },
  ],

  b: [
    { text: '3.1~10.6GHz' },
    { text: '<50m' },
    { text: '10cm 이하' },
    { text: '1' },
    { text: '-' },
    { text: '1' },
    { text: 'PoE' },
    { text: '보통' },
    { text: '★★★' },
    { text: '스마트 공장, 항만' },
    { text: '공장, 물류창고, 조선소, 플랜트, 건설현장 등' },
    { text: 'cm 단위의 초정밀 위치추적 가능<br/>노이즈가 심한 환경에서도 동작' },
    { text: 'API 제공' },
  ],
  c: [
    { text: '2.4GHz' },
    { text: '<30m' },
    { text: '10~30cm' },
    { text: '1' },
    { text: '1' },
    { text: '-' },
    { text: 'PoE' },
    { text: '낮음' },
    { text: '★★☆' },
    { text: '스마트 빌딩, 대형 실내' },
    { text: '오피스, 병원, 물류 자동화, 연구시설' },
    { text: '한개 설치만으로도 주변 태그 위치추적 가능' },
    { text: 'API 제공' },
  ],

  d: [
    { text: '2.4GHz' },
    { text: '최대 100m' },
    { text: '10cm 이상' },
    { text: '1' },
    { text: '-' },
    { text: '-' },
    { text: 'PoE' },
    { text: '매우 낮음' },
    { text: '★☆☆' },
    { text: '창고, 병원, 자산관리 공간 등' },
    { text: '대규모 자산관리' },
    { text: '구축 비용 낮음<br/>태그 배터리 소모량 적음' },
    { text: 'API 제공' },
  ],

  e: [
    { text: '3.1~10.6GHz' },
    { text: '20m' },
    { text: '10~30cm' },
    { text: '-' },
    { text: '-' },
    { text: '1' },
    { text: '충전형 배터리' },
    { text: '높음' },
    { text: '★☆☆' },
    { text: '소규모 데모, 임시공간' },
    { text: '임시 사용 현장, 소규모 공간, 인프라 공사가 어려운 곳' },
    { text: '앵커 설치 불필요<br/>휴대성 높음' },
    { text: '미제공 (앱 전용)' },
  ],

  spec: [
    {},

    {
      image: schemeUwb,
      link: '/rtls/uwb',
      title: 'TwinTracker UWB',
      desc: 'UWB',
    },
    {
      image: schemeAoa,
      link: '/rtls/aoa',
      title: 'TwinTracker AoA',
      desc: 'BLE + AoA',
    },

    {
      image: schemeBle,
      link: '/rtls/ble',
      title: 'TwinTracker BLE',
      desc: 'BLE',
    },
    {
      image: schemeComfort,
      link: '/rtls/comfort',
      title: 'Comfort Kit',
      desc: 'UWB',
    },
  ],
};
